import { render, staticRenderFns } from "./PlanListPage.vue?vue&type=template&id=16ffd2b2&scoped=true"
import script from "./PlanListPage.vue?vue&type=script&lang=js"
export * from "./PlanListPage.vue?vue&type=script&lang=js"
import style0 from "./PlanListPage.vue?vue&type=style&index=0&id=16ffd2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ffd2b2",
  null
  
)

export default component.exports